import "./tableComponent.scss";

import React, {useCallback, useState} from 'react';
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";
import Table from "@mui/material/Table";
import {ITableColumn} from "../../../models/table.model";
import _ from "lodash";
import TableSortLabel from '@mui/material/TableSortLabel';
import {ImageConfig} from "../../../../constants";
import LottieFileGenarationComponent from "../../core/lottie-file-genaration/LottieFileGenarationComponent";

interface TableComponentProps {
    isLoading?: boolean;
    isLoaded?: boolean;
    className?: string;
    isStickyHeader?: boolean;
    isHoverable?: boolean;
    columns: ITableColumn[];
    size?: "small" | "medium";
    handleSort?: Function
    data: any[];
    hideTableHeader?: boolean;
}

const TableComponent = (props: TableComponentProps) => {

    const {
        className,
        columns,
        isLoading,
        isLoaded,
        data,
        isHoverable,
        handleSort,
        hideTableHeader
    } = props;
    const [orderDirection, setOrderDirection] = useState<'asc' | 'desc'>("asc");
    const size = props.size || "medium";
    const isStickyHeader = props.isStickyHeader === undefined ? true : props.isStickyHeader;

    const renderTableCell = useCallback((item: any, column: ITableColumn, index: any) => {
        if (column.content) {
            return column.content(item, index);
        }
        return _.get(item, column.id);
    }, []);

    const handleSortRequest = (event: any) => {
        setOrderDirection(orderDirection === "asc" ? "desc" : "asc");
        const key = event.id;
        const sort: any = {};
        sort[key] = orderDirection
        if (handleSort) {
            handleSort(sort)
        }
    };

    return <>
        <div className={`table-container`}>
            <Table stickyHeader={isStickyHeader} size={size} className={"t-table " + className}>
                {!hideTableHeader && <TableHead className="t-table-head">
                    <TableRow className="t-table-row t-table-tr">
                        {columns.map((column) => (
                            <TableCell
                                className={`t-table-cell t-th t-th-${column.id} t-col-${column.id}`}
                                key={column.id}
                                align={column.align}
                            >
                                {column.sortable ?
                                    <TableSortLabel
                                        onClick={() => handleSortRequest(column)}
                                        active={true}
                                        direction={orderDirection}>{column.label}</TableSortLabel> :
                                    <>{column.label}</>}
                            </TableCell>
                        ))}
                    </TableRow>
                </TableHead>}
                {(data?.length && data?.length > 0)
                    ? <TableBody className="t-table-body">
                        {data.map((row: any) => {
                            return (
                                <TableRow className="t-table-row" id="rows_dd" hover={isHoverable} tabIndex={-1}
                                          key={row.id}>
                                    {columns.map((column, index: any) => {
                                        return (
                                            <TableCell
                                                className={`t-table-cell t-td t-td-${column.id} t-col-${column.id}`}
                                                key={column.id + index}
                                                // style={}
                                                align={column.align}>
                                                {renderTableCell(row, column, index)}
                                            </TableCell>
                                        );
                                    })}
                                </TableRow>
                            );
                        })}
                    </TableBody>
                    : <></>
                }
            </Table>
            {
                (isLoaded && !isLoading) && <>
                    {
                        (!data?.length || data?.length === 0) && <>
                            <div className="animated-gif-wrapper">
                                <img src={ImageConfig.NoDataGif} alt={"no data found"}/>
                                <div className="table-no-data-found">No data to show</div>
                            </div>
                        </>
                    }
                </>
            }
            {
               ( isLoading && !isLoaded ) && <div className={'table-loader-container'}>
                   <LottieFileGenarationComponent
                       loop={true}
                       autoplay={true}
                       animationData={ImageConfig.LoadingLottieFile} />

                </div>
            }
        </div>
    </>
};

export default TableComponent;
